export const API_SNIPPET_PANE_ID = 'api-snippet-pane';
export const API_SNIPPET_BROWSER_ID = 'api-snippet-browser';
export const API_SNIPPET_NAVIGATION_INSTRUCTIONS_ID = 'api-snippet-navigation-instructions';
export const API_SNIPPET_NAVIGATION_ITEM_SELECTOR = '[data-snippet-navigation-item="true"]';
